import React, { useEffect } from 'react';
import LocationPage from '../LocationPage';

const CarrolltonPage: React.FC = () => {
  useEffect(() => {
    document.title = 'AI & Cloud Solutions in Carrollton | FretDev';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'AI and cloud engineering services in Carrollton, TX. FretDev helps Carrollton businesses leverage GenAI, cloud architecture, and machine learning for competitive advantage.');
    }

    // Add location-specific schema
    const existingScript = document.querySelector('script[data-schema="carrollton-location"]');
    if (existingScript) {
      existingScript.remove();
    }

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'FretDev Carrollton',
      description: 'AI and cloud engineering services in Carrollton',
      areaServed: {
        '@type': 'City',
        name: 'Carrollton',
        state: 'Texas',
      },
      url: 'https://fretdev.com/locations/carrollton',
      sameAs: 'https://fretdev.com',
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-schema', 'carrollton-location');
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.querySelector('script[data-schema="carrollton-location"]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  const serviceAreas = [
    'Carrollton',
    'Farmers Branch',
    'Dallas',
    'Plano',
    'Irving',
    'Coppell',
    'Lewisville',
    'Flower Mound',
    'Arlington',
    'Fort Worth',
  ];

  const highlights = [
    'Home-Based Service: Headquartered in Carrollton serving the surrounding DFW communities',
    'Hyper-Local Support: Same-day consultations and rapid response for Carrollton businesses',
    'Small Business Focused: Solutions scaled specifically for Carrollton-area SMBs and growing companies',
    'Community Commitment: Active in the Carrollton business community',
    'Cost-Effective AI: Enterprise-grade solutions without the enterprise overhead',
  ];

  return (
    <LocationPage
      city="Carrollton"
      region="Dallas-Fort Worth"
      description="FretDev is based in Carrollton and serves businesses throughout the surrounding Dallas area. We understand the challenges facing regional companies — tight budgets, lean teams, and the need for rapid implementation. We deliver enterprise-quality AI and cloud solutions built for companies your size."
      serviceAreas={serviceAreas}
      highlights={highlights}
    />
  );
};

export default CarrolltonPage;
